<template>
  <!-- style="z-index:300;background-color: #F4F5FA;" -->
  <v-navigation-drawer
    v-model="drawer"
    style="z-index:300;"
    v-bind="$attrs"
    app
    width="270"
  >
    <default-drawer-header />

    <v-divider />

    <default-list :menu-list="menuList" />
  </v-navigation-drawer>
</template>
<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import _ from 'lodash';
export default {
  name: 'DefaultDrawer',
  components: {
    DefaultDrawerHeader: () => import(
      './DrawerHeader'
    ),
    DefaultList: () => import(
      './List'
    ),
  },
  computed: {
    ...mapState('app', {
      gradient: 'gradient',
      items: 'items',
      menus: 'menus'
    }),
    drawer: {
      get () {
        return this.$store.getters['app/getDrawer']
      },
      set (value) {
        return this.$store.commit('app/setDrawer', value)
      }
    },
  },
  data: () => ({
    menuList: [],
  }),
  async created(){
    this.$axios.defaults.headers.common["x-access-token"] = this.$store.getters.getAccessToken;
    this.$axios.defaults.headers.common["x-refresh-token"] = this.$store.getters.getRefreshToken;
    const token = this.$store.getters.getAccessToken
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(atob(base64).split("").map(function(c) {return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);}).join(""));
    let userData = JSON.parse(jsonPayload);
    

    async function removeMenu(menuList, parent, child) {
      let menuGroup = menuList.find(v => v.title === parent);
      const indexToRemove = menuGroup.items.findIndex(item => item.title === child);
      if (indexToRemove !== -1) {
        menuGroup.items.splice(indexToRemove, 1);
      }
    }

    let menuList = _.cloneDeep(this.menus);

    if (userData.level === null) {  // Pending { manager: null, level: null }
      await removeMenu(menuList, 'CONTENT', 'Samples');
      await removeMenu(menuList, 'CONTENT', 'Result');
      await removeMenu(menuList, 'CONTENT', 'Report');

      await removeMenu(menuList, 'USER', 'System Settings');
      await removeMenu(menuList, 'USER', '1:1 Inquiry');
    }
    if (userData.level === 0) {  // user { manager: 0, level: 0 }
      await removeMenu(menuList, 'CONTENT', 'Report');
      await removeMenu(menuList, 'USER', 'System Settings')
    }

    if (userData.level === 1) {
      if (userData.manager === 1) { // manager { manager: 1, level: 1 }
        await removeMenu(menuList, 'USER', 'System Settings');
      }
    }
    
    if (userData.level === 2) { // report { manager: 0, level: 2 }
      await removeMenu(menuList, 'CONTENT', 'Order');
      await removeMenu(menuList, 'CONTENT', 'Samples');
      await removeMenu(menuList, 'CONTENT', 'Result');
      await removeMenu(menuList, 'USER', 'System Settings');
      await removeMenu(menuList, 'USER', '1:1 Inquiry');
    }

    if (userData.level === 3) {  // 마이크로바이옴 수주고객 { manager: 0, level: 0 }
      await removeMenu(menuList, 'CONTENT', 'Samples');
      await removeMenu(menuList, 'CONTENT', 'Result');
      await removeMenu(menuList, 'CONTENT', 'Report');
      await removeMenu(menuList, 'CONTENT', 'MEASLES');
      await removeMenu(menuList, 'USER', 'System Settings');
    }

    if (userData.level === 4) {  // 질병청고객 { manager: 0, level: 4 }
      // ANALYTICS 섹션 전체 제거
      const analyticsIndex = menuList.findIndex(v => v.title === 'ANALYTICS');
      if (analyticsIndex !== -1) {
        menuList.splice(analyticsIndex, 1);
      }
      
      await removeMenu(menuList, 'CONTENT', 'Order Sheet');
      await removeMenu(menuList, 'CONTENT', 'Order List');
      await removeMenu(menuList, 'CONTENT', 'Samples');
      await removeMenu(menuList, 'CONTENT', 'Result');
      await removeMenu(menuList, 'CONTENT', 'Report');
      await removeMenu(menuList, 'USER', 'System Settings');
    }

    // level 4 또는 시스템 관리자(manager: 0, level: 1)가 아닌 경우 MEASLES 메뉴 숨김
    const isSystemAdmin = userData.manager === 0 && userData.level === 1;
    if (userData.level !== 4 && !isSystemAdmin) {
      await removeMenu(menuList, 'CONTENT', 'MEASLES');
    }

    this.menuList = menuList;
  },
}
</script>
